import React, { memo } from 'react';

type Props = {
  children: React.ReactNode;
  className?: string;
  /** Extra bottom offset when another sticky bar is visible (px). */
  offsetBottom?: number;
};

function StickyFormBarInner({ children, className = '', offsetBottom = 0 }: Props) {
  return (
    <div
      className={`sticky-form-bar ${className}`.trim()}
      style={offsetBottom ? { bottom: offsetBottom } : undefined}
      role="toolbar"
      aria-label="Form actions"
    >
      <div className="sticky-form-bar__inner">{children}</div>
    </div>
  );
}

const StickyFormBar = memo(StickyFormBarInner);
StickyFormBar.displayName = 'StickyFormBar';

export default StickyFormBar;
